"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const inversify_1 = require("inversify");
const del = require("del");
const urbanjs_tools_core_1 = require("urbanjs-tools-core");
const tool_1 = require("./tool");
exports.containerModule = new inversify_1.ContainerModule((bind) => {
    bind(urbanjs_tools_core_1.TYPE_DRIVER_DEL).toConstantValue(del);
    bind(urbanjs_tools_core_1.TYPE_TOOL).to(tool_1.Webpack).inSingletonScope();
});
